/* Missions.
 *
 * The mission types are Command PE's, because they are the right set and operators
 * already know them (COMMAND-PE-TEARDOWN.md §6.1).
 *
 * Areas are defined by REFERENCE POINT IDs, never by raw coordinates. Move the
 * reference point and every mission bound to it moves too — that is what reference
 * points are for (FR-SCEN-05).
 */

export type MissionType =
  | 'patrol'
  | 'strike'
  | 'support'
  | 'ferry'
  | 'cargo'
  | 'mining'
  | 'mine_clearing'

export const MISSION_LABEL: Record<MissionType, string> = {
  patrol: 'Patrol',
  strike: 'Strike',
  support: 'Support',
  ferry: 'Ferry',
  cargo: 'Cargo',
  mining: 'Mining',
  mine_clearing: 'Mine clearing',
}

export type Prosecution = 'ignore' | 'investigate' | 'engage'
export type EngageAuthority = 'on_authority' | 'on_detection' | 'self_defence'

export interface Mission {
  id: string
  name: string
  type: MissionType
  side: 'blue' | 'red'
  /** Reference point ids forming the area ring. Empty for ferry/cargo. */
  areaRefPoints: string[]
  /** Entity ids assigned. */
  assigned: string[]
  /** How many assigned units should be on station at once (patrol/support). */
  onStation: number
  investigate: Prosecution
  engage: EngageAuthority
  active: boolean
}

/* No seeded missions live here any more — they arrive in the scenario document. See
 * `refpoints.ts` for the same note; what stays is the schema and the type labels. */
